import React from 'react';
import CertificateCard from '../common/CertificateCard';

const facts = [
  ['Hash SHA-256', 'O conteúdo finalizado recebe uma impressão digital criptográfica associada ao registro do laudo.'],
  ['Código de validação', 'Cada registro pode ser conferido pela página pública usando o código de acesso correspondente.'],
  ['Histórico documental', 'Versões, emissão e revogação permanecem vinculadas ao histórico em vez de dependerem de arquivos soltos.'],
];

const Conformity = () => (
  <section className="bg-navy-2 py-24 md:py-32 px-4" aria-labelledby="confianca-title">
    <div className="max-w-7xl mx-auto">
      <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-12 lg:gap-20 items-start">
        <div>
          <h2 id="confianca-title" className="font-display text-3xl md:text-5xl font-bold tracking-[-0.025em] text-white mb-8">Confiança vem do que dá para <em className="font-semibold text-selo">verificar.</em></h2>
          <div className="space-y-7">
            {facts.map(([title, text]) => (
              <div key={title}><h3 className="text-lg font-semibold text-white mb-1">{title}</h3><p className="text-base leading-relaxed text-white/65">{text}</p></div>
            ))}
          </div>
        </div>

        <div className="space-y-8">
          <div className="relative"><p className="font-mono text-[9px] text-white/45 mb-2">DEMONSTRAÇÃO VISUAL</p><CertificateCard className="shadow-card" /></div>
          <div className="border-t border-white/15 pt-7">
            <p className="text-lg md:text-xl leading-relaxed text-white">A plataforma não emite assinatura digital ICP-Brasil. Ela registra integridade com hash SHA-256, dados de emissão, código de acesso e página pública de validação. Se a sua exigência é certificado ICP-Brasil, o Laudando ainda não atende. Preferimos dizer isso antes de você assinar.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Conformity;
